import {
  customEndpoint,
  getDirectusField,
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";
import client from "directus/src/client";

export async function fetchRevenueCalculationDashboard({ jobId, startDate, endDate, jobTagId }) {
  try {
    const params = new URLSearchParams();
    if (jobId) params.append("jobId", jobId);
    if (jobTagId) params.append("jobTagId", jobTagId);
    if (startDate) {
      params.append("startDate", startDate);
      params.append("start_date", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
      params.append("end_date", endDate);
    }

    const response = await client.request(
      customEndpoint({
        path: `/revenue-calculation/dashboard?${params.toString()}`,
        method: "GET",
      })
    );
    return response?.data ?? response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobMeta({ jobId, includeNextBillingDate = false }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "status",
        "type",
        "start_date",
        "end_date",
        "project.name",
        "coordinator",
        "project.coordinator",
        "project.project_id",
        "project.sales_coordinator",
        "project.id",
        "tags.id",
        "tags.tag.id",
        "tags.tag.label",
        ...(includeNextBillingDate ? ["next_billing_date"] : []),
      ],
    };
    const response = await getItemFromCollection("jobs", jobId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobMilestoneCount({ jobId }) {
  try {
    const query = {
      filter: {
        job: { _eq: jobId },
        status: { _eq: "in_progress" },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("milestones", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobBillablesCount({ jobId }) {
  try {
    const query = {
      filter: {
        job: { _eq: jobId },
        status: { _nin: ["cancelled", "collected", "archived"] },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("billables", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchJobStatuses() {
  try {
    const response = await getDirectusField("jobs", "status");

    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchJobTypes() {
  try {
    const response = await getDirectusField("jobs", "type");

    const data = response.meta.options.choices.map((type) => {
      return { name: type.text, id: type.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchJobFlags() {
  try {
    const response = await getDirectusField("jobs", "flag");

    const data = response.meta.options.choices.map((flag) => {
      return { name: flag.text, id: flag.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchProjects(search = "") {
  try {
    const query = {
      fields: ["id", "name"],
      filter: {
        status: {
          _eq: "active",
        },
      },
      search: search,
      sort: ["name"],
      limit: -1,
    };

    const data = await getItemsFromCollection("projects", query);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchProjectClient({ id }) {
  try {
    const query = {
      fields: [
        "client",
        "client.id",
        "client.company_id.name",
        "client.first_name",
        "client.last_name"
      ],
      filter: {
        id: { _eq: id },
      },
    };
    const response = await getItemsFromCollection("projects", query);
    return response[0].client;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
